import React, { FC } from 'react';
import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';

import { CurrencyInput, formatCurrencyValue } from '@eika/currency-input';
import { ButtonToggles } from '@eika/radio-button';

import { GjeldAksjonWeb, ValgtWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { GjeldFormData } from './gjeld';

interface Props {
    index: number;
    control: Control<GjeldFormData>;
    errors: FieldErrors<GjeldFormData>;
}

const Salgspant: FC<Props> = ({ index, control, errors }) => {
    const { gjeld, button, validationMessage } = useTranslation();
    const value = useWatch({ name: 'gjeld', control });

    return (
        <div className="form-box-seagreen margin-bottom-small">
            <span className="title margin-bottom-smaller">
                {gjeld.subTitleBillaan} - {value?.[index]?.laangiver}
            </span>
            <span className="row margin-bottom-medium">
                {value?.[index]?.registreringsnummer && (
                    <span>
                        {gjeld.infoBilensKjennetegn}: {value?.[index]?.registreringsnummer}
                    </span>
                )}
                <span>{`${gjeld.infoBilPant}: ${formatCurrencyValue(Number(value?.[index]?.pantebeloep))} kr`}</span>
            </span>
            <Controller
                control={control}
                name={`gjeld.${index}.restgjeld` as const}
                rules={{
                    required: `${validationMessage.requiredValue}`,
                }}
                render={({ field: { onChange, value } }) => (
                    <CurrencyInput
                        name={`gjeld.${index}.restgjeld` as const}
                        placeholder=""
                        className="max-width-200"
                        type="tel"
                        label={gjeld.labelBillaanSaldo}
                        value={value}
                        onValueChange={(v) => onChange(v.value)}
                        error={errors.gjeld?.[index]?.restgjeld?.message}
                    />
                )}
            />
            <Controller
                name={`gjeld.${index}.aksjon` as const}
                control={control}
                rules={{
                    validate: { ikkeValgtAksjon: (value: GjeldAksjonWeb) => value !== GjeldAksjonWeb.IKKE_VALGT },
                }}
                render={({ field: { onChange, value } }) => (
                    <ButtonToggles
                        label={gjeld.toggelsNedbetaleGjeld}
                        data-track-id="kreditt-boliglaan-gjeld-valg-nedbetale-gjeld"
                        data-track-linkname={value}
                        selectedOption={value}
                        onChange={(value) => onChange(value as ValgtWeb)}
                        options={[
                            { label: button.ja, value: GjeldAksjonWeb.ERSTATTES },
                            { label: button.nei, value: GjeldAksjonWeb.BEHOLDES },
                        ]}
                        errorMessage={
                            errors.gjeld?.[index]?.aksjon?.type === 'ikkeValgtAksjon'
                                ? `${validationMessage.requiredChoose}`
                                : ''
                        }
                    />
                )}
            />
        </div>
    );
};

export default Salgspant;
